// 这里的代码要被gff框架在运行时一开始注入，gff目前还没实现，所以只能各地方自己引入下列代码

import '@recept-pc-sdk/component/messageWithContext';
// import { elderlyOriented } from '@aligov/jssdk-utils';

// elderlyOriented.initPC(); // PC WEB 执行初始化

// 暂时兼容表单的uuid，后续说会去掉
let polyfillCrypto = false;
// @ts-ignore
if (typeof window.crypto !== 'object' && typeof window.msCrypto !== 'object') {
  polyfillCrypto = true;
}
if (polyfillCrypto) {
  // @ts-ignore
  window.crypto = {};
  function getRandomValues(e) {
    for (var r = e.length; r--; ) e[r] = Math.floor(256 * randomFloat());
    return e;
  }
  function randomFloat() {
    return Math.random();
  }
  window.crypto.getRandomValues = getRandomValues;
}

// CustomEvent ie polyfill from https://github.com/d4tocchini/customevent-polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    var ce = new window.CustomEvent('test', { cancelable: true });
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
      // IE has problems with .preventDefault() on custom events
      // http://stackoverflow.com/questions/23349191
      throw new Error('Could not prevent default');
    }
  } catch (e) {
    var CustomEvent = function (event, params) {
      var evt, origPrevent;
      params = params || {};
      params.bubbles = !!params.bubbles;
      params.cancelable = !!params.cancelable;

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      origPrevent = evt.preventDefault;
      evt.preventDefault = function () {
        origPrevent.call(this);
        try {
          Object.defineProperty(this, 'defaultPrevented', {
            get: function () {
              return true;
            },
          });
        } catch (e) {
          this.defaultPrevented = true;
        }
      };
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    // @ts-ignore
    window.CustomEvent = CustomEvent;
  }
})();
